(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerIsAlwaysSticky =
				this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener(
				'preventHeaderReveal',
				this.hideHeaderOnScrollUp
			);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			if (this.header) {
				observer.observe(this.header);
			}
		}

		onScroll() {
      if (this.header.querySelector('details-modal details').hasAttribute("open")) {
        return
      }

			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;

			if (
				this.headerIsAlwaysSticky &&
				scrollTop > this.header.offsetHeight + 1
			) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.style.transform = 'translateY(-100%)';
			}

			if (
				this.headerIsAlwaysSticky &&
				scrollTop > this.header.offsetHeight + 2
			) {
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)';
				this.header.style.transform = 'translateY(0)';
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
				this.header.style.transform = 'translateY(0)';
				this.header.style.transition = 'background var(--duration-short)';
			}

			if (
				scrollTop > this.currentScrollTop &&
				scrollTop > this.headerBounds.bottom
			) {
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (
				scrollTop < this.currentScrollTop &&
				scrollTop > this.headerBounds.bottom
			) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky'
			);
			this.closeMenuDisclosure();
			this.closeSearchModal();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate'
			);
		}

		closeMenuDisclosure() {
			this.disclosures =
				this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => disclosure.close());
			}
		}

		closeSearchModal() {
			this.searchModal = this.searchModal || this.header.querySelector('details-modal');
			this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		const activeMediaTemplate = activeMedia.querySelector('template');
		const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (
			activeMedia.nodeName == 'DEFERRED-MEDIA' &&
			activeMediaContent &&
			activeMediaContent.querySelector('.js-youtube') && activeMediaContent.querySelector('.js-vimeo')
		)
			activeMedia.loadContent();
	}
}

class RelatedProduct extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const related = html.querySelector('.related-product');
					if (related && related.innerHTML.trim().length) {
						this.innerHTML = related.innerHTML;
					}

					/* Toggle content */
					$('.product-description-more').click(function (e) {
						e.preventDefault();
						$(this).closest('.product-description-short').next().show();
						$(this).closest('.product-description-short').hide();
					});

					$('.product-description-less').click(function (e) {
						e.preventDefault();
						$(this).closest('.product-description-full').prev().show();
						$(this).closest('.product-description-full').hide();
					});
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

class RelatedSlider extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

		fetch(this.dataset.url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
				if (relatedSlider && relatedSlider.innerHTML.trim().length) {
					this.innerHTML = relatedSlider.innerHTML;
				}

				/* Related products slider */
				const slider = this.querySelector('.related-slider__list');
				const prevBtn = this.querySelector('.related-slider__button-prev');
				const nextBtn = this.querySelector('.related-slider__button-next');
				if (document.querySelector('.related-slider__list')) {
					const productSlider = new Swiper(slider, {
						slidesPerView: 1,
						spaceBetween: 10,
						navigation: {
							nextEl: nextBtn,
							prevEl: prevBtn,
						},
						breakpoints: {
						
						}
					});
				}

				/* Color swatches */
				const generateSrcset = (image, widths = []) => {
					const imageUrl = new URL(image["src"]);
					return widths.filter((width) => width <= image["width"]).map((width) => {
						imageUrl.searchParams.set("width", width.toString());
						return `${imageUrl.href} ${width}w`;
					}).join(", ");
				}

				const createImageElement = (image, classes, sizes, productTitle) => {
					const previewImage = image["preview_image"];
					const newImage = new Image(previewImage["width"], previewImage["height"]);
					newImage.className = classes;
					newImage.alt = image["alt"] || productTitle;
					newImage.sizes = sizes;
					newImage.src = previewImage["src"];
					newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
					newImage.loading="lazy"
					return newImage;
				}

				const checkSwatches = () => {
					document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
						wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
							input.addEventListener('click', (event) => {
								const primaryImage = wrapper.querySelector(".media--first");
								const secondaryImage = wrapper.querySelector(".media--second");
								const handleProduct = wrapper.dataset.product;
								
								if (event.currentTarget.checked && primaryImage) {
									wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
									if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
										wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
										wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
										wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
										wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
									}
									
									const currentColor = event.currentTarget.value;

									jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
										const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

										if (variant) {
											const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
											
											if (newPrimaryImage.src !== primaryImage.src) {
												let flag = false;
												if (secondaryImage) {
													const secondaryImagePathname = new URL(secondaryImage.src).pathname;
													const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

													if (secondaryImagePathname == newPrimaryImagePathname) {
														primaryImage.remove();
														secondaryImage.classList.remove('media--second');
														secondaryImage.classList.add('media--first');
														flag = true;
													} 
												}
												if (flag == false) {
													primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
													setTimeout(function(){
														primaryImage.replaceWith(newPrimaryImage);
														newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
														if (secondaryImage) {
															secondaryImage.remove();                                    
														}
													}, 200);
												}
											}
										}
									});
								}
							})
						})
					})
				}

				checkSwatches();
			})
			.catch((e) => {
				console.error(e);
			});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('related-product', RelatedProduct);
customElements.define('related-slider', RelatedSlider);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
		}

			connectedCallback() {

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						/* Color swatches */
						const generateSrcset = (image, widths = []) => {
							const imageUrl = new URL(image['src']);
							return widths
								.filter((width) => width <= image['width'])
								.map((width) => {
									imageUrl.searchParams.set('width', width.toString());
									return `${imageUrl.href} ${width}w`;
								})
								.join(', ');
						};

						const createImageElement = (
							image,
							classes,
							sizes,
							productTitle
						) => {
							const previewImage = image['preview_image'];
							const newImage = new Image(
								previewImage['width'],
								previewImage['height']
							);
							newImage.className = classes;
							newImage.alt = image['alt'] || productTitle;
							newImage.sizes = sizes;
							newImage.src = previewImage['src'];
							newImage.srcset = generateSrcset(
								previewImage,
								[165, 360, 533, 720, 940, 1066]
							);
							newImage.loading = 'lazy';
							return newImage;
						};

						const checkSwatches = () => {
							document
								.querySelectorAll('.js-color-swatches-wrapper')
								.forEach((wrapper) => {
									wrapper
										.querySelectorAll('.js-color-swatches input')
										.forEach((input) => {
											input.addEventListener('click', (event) => {
												const primaryImage =
													wrapper.querySelector('.media--first');
												const secondaryImage =
													wrapper.querySelector('.media--second');
												const handleProduct = wrapper.dataset.product;

												if (event.currentTarget.checked && primaryImage) {
													wrapper
														.querySelector('.js-color-swatches-link')
														.setAttribute(
															'href',
															event.currentTarget.dataset.variantLink
														);
													if (
														wrapper.querySelector(
															'.card__add-to-cart button[name="add"]'
														)
													) {
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"]'
															)
															.setAttribute('aria-disabled', false);
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] > span'
															)
															.classList.remove('hidden');
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] .sold-out-message'
															)
															.classList.add('hidden');
														wrapper.querySelector(
															'.card__add-to-cart input[name="id"]'
														).value = event.currentTarget.dataset.variantId;
													}

													const currentColor = event.currentTarget.value;

													jQuery.getJSON(
														window.Shopify.routes.root +
															`products/${handleProduct}.js`,
														function (product) {
															const variant = product.variants.filter(
																(item) =>
																	item.featured_media != null &&
																	item.options.includes(currentColor)
															)[0];

															if (variant) {
																const newPrimaryImage = createImageElement(
																	variant['featured_media'],
																	primaryImage.className,
																	primaryImage.sizes,
																	product.title
																);

																if (newPrimaryImage.src !== primaryImage.src) {
																	let flag = false;
																	if (secondaryImage) {
																		const secondaryImagePathname = new URL(
																			secondaryImage.src
																		).pathname;
																		const newPrimaryImagePathname = new URL(
																			newPrimaryImage.src
																		).pathname;

																		if (
																			secondaryImagePathname ==
																			newPrimaryImagePathname
																		) {
																			primaryImage.remove();
																			secondaryImage.classList.remove(
																				'media--second'
																			);
																			secondaryImage.classList.add(
																				'media--first'
																			);
																			flag = true;
																		}
																	}
																	if (flag == false) {
																		primaryImage.animate(
																			{ opacity: [1, 0] },
																			{
																				duration: 200,
																				easing: 'ease-in',
																				fill: 'forwards',
																			}
																		).finished;
																		setTimeout(function () {
																			primaryImage.replaceWith(newPrimaryImage);
																			newPrimaryImage.animate(
																				{ opacity: [0, 1] },
																				{ duration: 200, easing: 'ease-in' }
																			);
																			if (secondaryImage) {
																				secondaryImage.remove();
																			}
																		}, 200);
																	}
																}
															}
														}
													);
												}
											});
										});
								});
						};

						const initProductCarouselSliders = () => {
							const prodCarslideshows = document.querySelectorAll(
								'.product-recommendations-swiper'
							);

							prodCarslideshows.forEach((prodSlideshow) => {
								const productCount = parseInt(
									prodSlideshow
										.querySelector('.swiper-wrapper')
										.getAttribute('data-count')
								);

								const productCountMobile = parseInt(
									prodSlideshow
										.querySelector('.swiper-wrapper')
										.getAttribute('data-count-mobile')
								);

								const prodCardprodSlideshow = new Swiper(prodSlideshow, {
									loop: false,
									autoHeight: true,
									allowTouchMove: true,
									slidesPerView: productCount,
									lazy: true,
									preloadImages: false,
									spaceBetween: 24,
									navigation: {
										nextEl: '.swiper-button-next',
										prevEl: '.swiper-button-prev',
									},
									on: {
										resize: function () {
											var windowWidth = window.innerWidth;

											if (productCount == 6) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else if (windowWidth < 1200) {
													this.params.slidesPerView = 3;
												} else if (windowWidth < 1360) {
													this.params.slidesPerView = 4;
												} else if (windowWidth < 1600) {
													this.params.slidesPerView = 5;
												} else {
													this.params.slidesPerView = 6;
												}
											} else if (productCount == 5) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else if (windowWidth < 1200) {
													this.params.slidesPerView = 3;
												} else if (windowWidth < 1360) {
													this.params.slidesPerView = 4;
												} else {
													this.params.slidesPerView = 5;
												}
											} else if (productCount == 4) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else if (windowWidth < 1200) {
													this.params.slidesPerView = 3;
												} else {
													this.params.slidesPerView = 4;
												}
											} else if (productCount == 3) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else {
													this.params.slidesPerView = 3;
												}
											} else if (productCount == 2) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else {
													this.params.slidesPerView = 2;
												}
											}
										},
									},
								});
							});
						};

						checkSwatches();
						initProductCarouselSliders();
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
function initRecentlyViewed() {
  var el = document.querySelector('[id^="recently-viewed-"]');
  if (!el) return;

  var max = parseInt(el.dataset.max, 10) || 6;
  var routesRoot = el.dataset.routesRoot || '/';
  var columns = parseInt(el.dataset.columns, 10) || 4;
  var columnsMobile = parseInt(el.dataset.columnsMobile, 10) || 1;
  var currentHandle = el.dataset.currentHandle || '';

  var headingEl = el.querySelector('.recently-viewed__heading');
  var swiperEl = el.querySelector('.swiper-container');
  var wrapperEl = el.querySelector('.swiper-wrapper');

  if (routesRoot.charAt(routesRoot.length - 1) !== '/') {
    routesRoot += '/';
  }

  var STORAGE_KEY = 'recently_viewed_products';
  var MAX_STORED = 30;

  /* ── Read stored handles ── */
  var stored = [];
  try {
    stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch(e) {
    stored = [];
  }

  /* ── Save current product to list (most recent first) ── */
  if (currentHandle) {
    stored = stored.filter(function(h) { return h !== currentHandle; });
    stored.unshift(currentHandle);
    if (stored.length > MAX_STORED) stored = stored.slice(0, MAX_STORED);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch(e) {}
  }

  /* ── Get handles to display (exclude current product) ── */
  var toShow = stored.filter(function(h) { return h !== currentHandle; }).slice(0, max);

  if (toShow.length === 0) {
    el.style.display = 'none';
    return;
  }

  /* ── Fetch rendered product cards via Section Rendering API ── */
  var cardPromises = toShow.map(function(handle) {
    var cardUrl = routesRoot + 'products/' + handle + '?section_id=related-card-template';
    return fetch(cardUrl)
      .then(function(res) { return res.ok ? res.text() : null; })
      .catch(function() { return null; });
  });

  Promise.all(cardPromises).then(function(htmlArray) {
    htmlArray.forEach(function(html) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var slide = tmp.querySelector('.collection-product-card');
      if (slide) {
        wrapperEl.appendChild(slide);
      }
    });

    if (wrapperEl.children.length === 0) {
      el.style.display = 'none';
      return;
    }

    if (headingEl) headingEl.style.display = '';
    swiperEl.style.display = '';

    /* ── Initialize Swiper ── */
    waitForSwiperRV(function() {
      new Swiper(swiperEl, {
        loop: false,
        autoHeight: true,
        allowTouchMove: true,
        slidesPerView: columns,
        lazy: true,
        preloadImages: false,
        spaceBetween: 24,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          0: { slidesPerView: columnsMobile },
          576: { slidesPerView: Math.min(2, columns) },
          750: { slidesPerView: Math.min(3, columns) },
          1200: { slidesPerView: Math.min(4, columns) },
          1360: { slidesPerView: Math.min(5, columns) },
          1600: { slidesPerView: columns }
        }
      });
    });

    /* ── Initialize color swatches ── */
    initSwatchesRV();

  }).catch(function(err) {
    console.error('Recently viewed error:', err);
    el.style.display = 'none';
  });

  function waitForSwiperRV(cb) {
    if (typeof Swiper !== 'undefined') return cb();
    var t = setInterval(function() {
      if (typeof Swiper !== 'undefined') { clearInterval(t); cb(); }
    }, 200);
  }

  function initSwatchesRV() {
    var generateSrcset = function(image, widths) {
      var imageUrl = new URL(image['src']);
      return widths
        .filter(function(w) { return w <= image['width']; })
        .map(function(w) {
          imageUrl.searchParams.set('width', w.toString());
          return imageUrl.href + ' ' + w + 'w';
        })
        .join(', ');
    };

    var createImageElement = function(image, classes, sizes, productTitle) {
      var previewImage = image['preview_image'];
      var newImage = new Image(previewImage['width'], previewImage['height']);
      newImage.className = classes;
      newImage.alt = image['alt'] || productTitle;
      newImage.sizes = sizes;
      newImage.src = previewImage['src'];
      newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
      newImage.loading = 'lazy';
      return newImage;
    };

    el.querySelectorAll('.js-color-swatches-wrapper').forEach(function(wrapper) {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(function(input) {
        input.addEventListener('click', function(event) {
          var primaryImage = wrapper.querySelector('.media--first');
          var secondaryImage = wrapper.querySelector('.media--second');
          var handleProduct = wrapper.dataset.product;

          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link')
              .setAttribute('href', event.currentTarget.dataset.variantLink);

            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]')
                .setAttribute('aria-disabled', false);
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span')
                .classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                .classList.add('hidden');
              wrapper.querySelector('.card__add-to-cart input[name="id"]')
                .value = event.currentTarget.dataset.variantId;
            }

            var currentColor = event.currentTarget.value;

            jQuery.getJSON(
              window.Shopify.routes.root + 'products/' + handleProduct + '.js',
              function(product) {
                var variant = product.variants.filter(function(item) {
                  return item.featured_media != null && item.options.includes(currentColor);
                })[0];

                if (variant) {
                  var newPrimaryImage = createImageElement(
                    variant['featured_media'],
                    primaryImage.className,
                    primaryImage.sizes,
                    product.title
                  );

                  if (newPrimaryImage.src !== primaryImage.src) {
                    var flag = false;
                    if (secondaryImage) {
                      var secondaryImagePathname = new URL(secondaryImage.src).pathname;
                      var newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;
                      if (secondaryImagePathname == newPrimaryImagePathname) {
                        primaryImage.remove();
                        secondaryImage.classList.remove('media--second');
                        secondaryImage.classList.add('media--first');
                        flag = true;
                      }
                    }
                    if (flag == false) {
                      primaryImage.animate(
                        { opacity: [1, 0] },
                        { duration: 200, easing: 'ease-in', fill: 'forwards' }
                      ).finished;
                      setTimeout(function() {
                        primaryImage.replaceWith(newPrimaryImage);
                        newPrimaryImage.animate(
                          { opacity: [0, 1] },
                          { duration: 200, easing: 'ease-in' }
                        );
                        if (secondaryImage) {
                          secondaryImage.remove();
                        }
                      }, 200);
                    }
                  }
                }
              }
            );
          }
        });
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
} else {
  initRecentlyViewed();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-metafield"] && !Shopify.designMode) return;
  try {
    
function initRelatedByMetafield() {
  var el = document.querySelector('[id^="related-by-metafield-"]');
  if (!el) return;

  /*
   * Extract product handle from URL instead of Liquid data attribute.
   * product.handle can be blank when the section is loaded via AJAX.
   * URL is always: /[locale/]products/HANDLE[?params]
   */
  var productHandle = (function() {
    var parts = window.location.pathname.split('/products/');
    if (parts.length > 1) {
      return parts[1].split('/')[0].split('?')[0];
    }
    return el.dataset.productHandle || null;
  })();
  var collectionUrlEn = hasEn ? el.dataset.collectionUrlEn : null;
  var collectionUrlLocal = el.dataset.collectionUrl;
  var collectionUrl = collectionUrlEn || collectionUrlLocal;
  var currentId = parseInt(el.dataset.currentProduct, 10);
  var max = parseInt(el.dataset.max, 10) || 6;
  var routesRoot = el.dataset.routesRoot || '/';
  var columns = parseInt(el.dataset.columns, 10) || 4;
  var columnsMobile = parseInt(el.dataset.columnsMobile, 10) || 1;

  var loadingEl = el.querySelector('.related-by-metafield__loading');
  var swiperEl = el.querySelector('.swiper-container');
  var wrapperEl = el.querySelector('.swiper-wrapper');
  var headingEl = el.querySelector('.related-by-metafield__heading');

  if (!productHandle || !collectionUrl) {
    el.style.display = 'none';
    return;
  }

  if (routesRoot.charAt(routesRoot.length - 1) !== '/') {
    routesRoot += '/';
  }

  /*
   * Phase 0: Get current product's color and design values.
   * 
   * Strategy:
   * 1. Try /en/ route first (works on multilingual stores, returns EN values)
   * 2. If /en/ fails (404), fall back to current locale route
   * 3. If metafield values are translated (don't match any tag), use tag matching
   *    with known color/design lists as fallback
   * 
   * The metafield values from the helper are matched against the product's tags
   * (which are always in English) to ensure we search with English values.
   */
  var hasEn = (el.dataset.hasEn || '').trim() === 'true';
  var localHelperUrl = routesRoot + 'products/' + productHandle + '?section_id=related-metafield-helper';
  var helperUrl = hasEn ? '/en/products/' + productHandle + '?section_id=related-metafield-helper' : localHelperUrl;

  function fetchHelper(url) {
    return fetch(url)
      .then(function(res) {
        if (!res.ok) throw new Error('not ok');
        return res.text();
      })
      .then(function(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var helper = tmp.querySelector('#metafield-helper-output');
        var c = helper ? (helper.dataset.color || '').trim() : '';
        var d = helper ? (helper.dataset.design || '').trim() : '';
        return { color: c, design: d, html: html };
      });
  }

  fetchHelper(helperUrl)
    .then(function(result) {
      /* If /en/ returned empty metafields, retry on current locale */
      if (!result.color && !result.design && localHelperUrl !== helperUrl) {
        return fetchHelper(localHelperUrl);
      }
      return result;
    })
    .catch(function() {
      /* /en/ failed entirely, try current locale */
      return fetchHelper(localHelperUrl);
    })
    .then(function(result) {
      var metaColor = result.color;
      var metaDesign = result.design;

      /* Now fetch product tags (always English) and resolve final values */
      return fetch(routesRoot + 'products/' + productHandle + '.js')
        .then(function(res) { return res.json(); })
        .then(function(productData) {
          var tags = productData.tags.map(function(t) { return t.toLowerCase(); });

          var COLORS = [
            'beige','black','black & white','blue','brown','cream','gold',
            'green','grey','ivory','multicolor','navy','orange','pink',
            'purple','red','rust','silver','taupe','terracotta','turquoise',
            'white','yellow','anthracite','charcoal','copper','coral',
            'fuchsia','khaki','lavender','lilac','magenta','mauve',
            'mint','mustard','natural','nude','ochre','olive','peach',
            'petrol','plum','sage','salmon','sand','sienna','teal','wine'
          ];
          var DESIGNS = [
            'abstract','animal print','bohemian','borders','check','chevron',
            'classic','damask','ethnic','floral','geometric','gradation',
            'herringbone','medallion','modern art','moroccan','mottled',
            'oriental','paisley','patchwork','plain','polka dot','retro',
            'scandinavian','striped','traditional','tribal','vintage',
            'watercolor','zigzag'
          ];

          var colorTag = '';
          var designTag = '';

          /* If metafield values match a tag directly, use them (EN store or /en/ worked) */
          if (metaColor && tags.indexOf(metaColor.toLowerCase()) !== -1) {
            colorTag = metaColor.toLowerCase();
          }
          if (metaDesign && tags.indexOf(metaDesign.toLowerCase()) !== -1) {
            designTag = metaDesign.toLowerCase();
          }

          /* 
           * Fallback: metafield values are translated and don't match tags.
           * Find all color tags and all design tags on this product.
           * Use metafield count to pick the right one by position.
           * E.g., if metafield has 1 design value, product should have 1 design tag.
           *       if metafield has 2 design values, first metafield = first design tag.
           */
          if (!colorTag) {
            var colorTags = tags.filter(function(t) { return COLORS.indexOf(t) !== -1; });
            if (colorTags.length > 0) {
              colorTag = colorTags[0];
            }
          }

          if (!designTag) {
            var designTags = tags.filter(function(t) { return DESIGNS.indexOf(t) !== -1; });
            if (designTags.length > 0) {
              designTag = designTags[0];
            }
          }

          return {
            colorTag: colorTag,
            designTag: designTag,
            /* If metafield design didn't match directly, pass all candidates for Phase 1 to try */
            designCandidates: (metaDesign && tags.indexOf(metaDesign.toLowerCase()) !== -1)
              ? [designTag]
              : designTags
          };
        });
    })
    .then(function(result) {
      var colorTag = result.colorTag;
      var designTag = result.designTag;
      var designCandidates = result.designCandidates || [designTag];

      if (!colorTag || designCandidates.length === 0) {
        el.style.display = 'none';
        return;
      }

      /* ── Phase 1: Find ALL matching products via paginated fetch + tag filter ── */
      var allMatched = [];
      var page = 1;
      var maxPages = 15;
      /* Collect more than we need so we can diversify by vendor */
      var collectLimit = max * 10;

      function fetchPage() {
        var url = collectionUrl + '/products.json?limit=250&page=' + page;

        return fetch(url)
          .then(function(res) {
            if (!res.ok) throw new Error('Fetch failed: ' + res.status);
            return res.json();
          })
          .then(function(data) {
            var products = data.products || [];

            /* If EN URL returns empty on first page, fallback to local URL */
            if (products.length === 0 && page === 1 && collectionUrl === collectionUrlEn && collectionUrlLocal !== collectionUrlEn) {
              collectionUrl = collectionUrlLocal;
              return fetchPage();
            }

            if (products.length === 0) return;

            products.forEach(function(p) {
              if (p.id === currentId) return;
              if (allMatched.length >= collectLimit) return;

              var pTags = p.tags.map(function(t) { return t.toLowerCase(); });
              /* Match color AND any of the design candidates */
              if (pTags.indexOf(colorTag) !== -1) {
                for (var dc = 0; dc < designCandidates.length; dc++) {
                  if (pTags.indexOf(designCandidates[dc]) !== -1) {
                    allMatched.push(p);
                    break;
                  }
                }
              }
            });

            if (allMatched.length < collectLimit && products.length === 250 && page < maxPages) {
              page++;
              return fetchPage();
            }
          });
      }

      return fetchPage().then(function() {
        if (allMatched.length === 0) {
          el.style.display = 'none';
          return;
        }

        /* ── Diversify by vendor: 1 per vendor first, then fill remaining ── */
        var matched = [];
        var usedVendors = {};
        var remaining = [];

        /* First pass: one product per vendor */
        allMatched.forEach(function(p) {
          var vendor = (p.vendor || '').toLowerCase();
          if (!usedVendors[vendor] && matched.length < max) {
            matched.push(p);
            usedVendors[vendor] = true;
          } else {
            remaining.push(p);
          }
        });

        /* Second pass: fill up with remaining products if needed */
        if (matched.length < max) {
          remaining.forEach(function(p) {
            if (matched.length < max) {
              matched.push(p);
            }
          });
        }

        /* ── Phase 2: Fetch rendered product cards via Section Rendering API ── */
        var cardPromises = matched.map(function(p) {
          var cardUrl = routesRoot + 'products/' + p.handle + '?section_id=related-card-template';
          return fetch(cardUrl)
            .then(function(res) { return res.ok ? res.text() : null; })
            .catch(function() { return null; });
        });

        return Promise.all(cardPromises).then(function(htmlArray) {
          if (!htmlArray || htmlArray.length === 0) {
            el.style.display = 'none';
            return;
          }

          htmlArray.forEach(function(html) {
            if (!html) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var slide = tmp.querySelector('.collection-product-card');
            if (slide) {
              wrapperEl.appendChild(slide);
            }
          });

          if (wrapperEl.children.length === 0) {
            el.style.display = 'none';
            return;
          }

          loadingEl.style.display = 'none';
          swiperEl.style.display = '';

          /* ── Phase 3: Initialize Swiper + color swatches ── */
          waitForSwiper(function() {
            new Swiper(swiperEl, {
              loop: false,
              autoHeight: true,
              allowTouchMove: true,
              slidesPerView: columns,
              lazy: true,
              preloadImages: false,
              spaceBetween: 24,
              navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev')
              },
              breakpoints: {
                0: { slidesPerView: columnsMobile },
                576: { slidesPerView: Math.min(2, columns) },
                750: { slidesPerView: Math.min(3, columns) },
                1200: { slidesPerView: Math.min(4, columns) },
                1360: { slidesPerView: Math.min(5, columns) },
                1600: { slidesPerView: columns }
              }
            });
          });

          initSwatches();
        });
      });
    })
    .catch(function(err) {
      console.error('Related by metafield error:', err);
      el.style.display = 'none';
    });

  /* ── Helper: wait for Swiper library ── */
  function waitForSwiper(cb) {
    if (typeof Swiper !== 'undefined') return cb();
    var t = setInterval(function() {
      if (typeof Swiper !== 'undefined') { clearInterval(t); cb(); }
    }, 200);
  }

  /* ── Helper: initialize color swatches (same logic as theme) ── */
  function initSwatches() {
    var generateSrcset = function(image, widths) {
      var imageUrl = new URL(image['src']);
      return widths
        .filter(function(w) { return w <= image['width']; })
        .map(function(w) {
          imageUrl.searchParams.set('width', w.toString());
          return imageUrl.href + ' ' + w + 'w';
        })
        .join(', ');
    };

    var createImageElement = function(image, classes, sizes, productTitle) {
      var previewImage = image['preview_image'];
      var newImage = new Image(previewImage['width'], previewImage['height']);
      newImage.className = classes;
      newImage.alt = image['alt'] || productTitle;
      newImage.sizes = sizes;
      newImage.src = previewImage['src'];
      newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
      newImage.loading = 'lazy';
      return newImage;
    };

    el.querySelectorAll('.js-color-swatches-wrapper').forEach(function(wrapper) {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(function(input) {
        input.addEventListener('click', function(event) {
          var primaryImage = wrapper.querySelector('.media--first');
          var secondaryImage = wrapper.querySelector('.media--second');
          var handleProduct = wrapper.dataset.product;

          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link')
              .setAttribute('href', event.currentTarget.dataset.variantLink);

            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]')
                .setAttribute('aria-disabled', false);
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span')
                .classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                .classList.add('hidden');
              wrapper.querySelector('.card__add-to-cart input[name="id"]')
                .value = event.currentTarget.dataset.variantId;
            }

            var currentColor = event.currentTarget.value;

            jQuery.getJSON(
              window.Shopify.routes.root + 'products/' + handleProduct + '.js',
              function(product) {
                var variant = product.variants.filter(function(item) {
                  return item.featured_media != null && item.options.includes(currentColor);
                })[0];

                if (variant) {
                  var newPrimaryImage = createImageElement(
                    variant['featured_media'],
                    primaryImage.className,
                    primaryImage.sizes,
                    product.title
                  );

                  if (newPrimaryImage.src !== primaryImage.src) {
                    var flag = false;
                    if (secondaryImage) {
                      var secondaryImagePathname = new URL(secondaryImage.src).pathname;
                      var newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;
                      if (secondaryImagePathname == newPrimaryImagePathname) {
                        primaryImage.remove();
                        secondaryImage.classList.remove('media--second');
                        secondaryImage.classList.add('media--first');
                        flag = true;
                      }
                    }
                    if (flag == false) {
                      primaryImage.animate(
                        { opacity: [1, 0] },
                        { duration: 200, easing: 'ease-in', fill: 'forwards' }
                      ).finished;
                      setTimeout(function() {
                        primaryImage.replaceWith(newPrimaryImage);
                        newPrimaryImage.animate(
                          { opacity: [0, 1] },
                          { duration: 200, easing: 'ease-in' }
                        );
                        if (secondaryImage) {
                          secondaryImage.remove();
                        }
                      }, 200);
                    }
                  }
                }
              }
            );
          }
        });
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelatedByMetafield);
} else {
  initRelatedByMetafield();
}

  } catch(e) { console.error(e); }
})();
})();
